export default Object.freeze({
  SpecialistLicense: 1,
  Collegiation: 2,
  Law300: 3,
  CertForCyberTherapy: 4,
});
